

import React from 'react';
import { translateThis } from '../../helpers/language.helper';

export const PasswordRequirementCheckBoxes = ({ rules }) => {
    
    return (
        <div className='password-requirement-points' style={{ marginTop: '0' }}>
            <ul>
                <li className={rules.eightCharacter ? 'checked' : ''}>{translateThis('At least 8 characters long')}</li>
                <li className={rules.containNumber ? 'checked' : ''}>{translateThis('1 number')}</li>
                <li className={rules.containUpperCase ? 'checked' : ''}>{translateThis('1 uppercase character')}</li>
                <li className={rules.containSpecialChar ? 'checked' : ''}>{translateThis('1 special symbol')}</li>
            </ul>
        </div>
    )
}